<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
      <f7-nav-title>Tarifas — Herramientas y Versiones</f7-nav-title>
    </f7-navbar>
    <f7-page-content>
      <div class="tl-wrap">
        <!-- Filtros -->
        <f7-card class="tl-card">
          <div class="tl-ch">FILTROS</div>
          <f7-card-content>
            <div class="tl-filtros">
              <div class="tl-f-item">
                <label>Herramienta:</label>
                <select v-model="filtro.codigo" class="tl-select">
                  <option value="">Todas</option>
                  <option v-for="c in codigosUnicos" :key="c" :value="c">{{ c }}</option>
                </select>
              </div>
              <div class="tl-f-item">
                <label>Estado:</label>
                <select v-model="filtro.estado" class="tl-select">
                  <option value="">Todos</option>
                  <option value="vigente">Vigente</option>
                  <option value="cerrada">Cerrada</option>
                </select>
              </div>
              <div class="tl-f-item">
                <label>Desde:</label>
                <input type="date" v-model="filtro.fechaDesde" class="tl-date" />
              </div>
              <div class="tl-f-item">
                <label>Hasta:</label>
                <input type="date" v-model="filtro.fechaHasta" class="tl-date" />
              </div>
              <f7-button small fill color="blue" @click="filtrar">Filtrar</f7-button>
              <f7-button small color="gray" @click="limpiar">Limpiar</f7-button>
            </div>
          </f7-card-content>
        </f7-card>

        <!-- Tabla -->
        <f7-card class="tl-card">
          <div class="tl-ch">
            <span>{{ herramientasFiltradas.length }} VERSIONES ENCONTRADAS</span>
            <div class="tl-ch-links">
              <a class="link" href="/tarifas/editor-herramientas/" style="color:#E8901A;font-size:10px">Editor</a>
              <a class="link" href="/tarifas/config-global/" style="color:#7dd3fc;font-size:10px;margin-left:10px">Config Global</a>
            </div>
          </div>
          <f7-card-content style="padding:0">
            <f7-block v-if="loading" class="text-align-center"><f7-preloader></f7-preloader></f7-block>
            <div v-else-if="!herramientasFiltradas.length" class="tl-empty">Sin resultados</div>
            <div v-else style="overflow-x:auto">
              <table class="tl-table">
                <thead>
                  <tr>
                    <th>Codigo</th>
                    <th>Nombre</th>
                    <th>Familia</th>
                    <th>Version</th>
                    <th>Fecha Desde</th>
                    <th>Fecha Hasta</th>
                    <th>Estado</th>
                    <th>Config Global</th>
                    <th>Motivo</th>
                    <th>Modificado por</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(h, idx) in herramientasFiltradas"
                    :key="h.id || idx"
                    :class="{ 'tl-row-closed': !esVigente(h) }"
                    class="tl-row"
                    @click="abrirDetalle(h)"
                  >
                    <td><b>{{ h.codigo }}</b></td>
                    <td>{{ h.nombre }}</td>
                    <td>{{ h.familia }}</td>
                    <td>v.{{ h.version || 1 }}</td>
                    <td>{{ formatFecha(h.fechaDesde) }}</td>
                    <td>
                      <span v-if="!h.fechaHasta" class="tl-badge tl-vigente">Vigente</span>
                      <span v-else>{{ formatFecha(h.fechaHasta) }}</span>
                    </td>
                    <td>
                      <span class="tl-badge" :class="esVigente(h) ? 'tl-vigente' : 'tl-cerrada'">
                        {{ esVigente(h) ? 'Vigente' : 'Cerrada' }}
                      </span>
                    </td>
                    <td>{{ h.configGlobalVersion ? 'v.' + h.configGlobalVersion : '—' }}</td>
                    <td>{{ h.motivo || '—' }}</td>
                    <td>{{ h.modificadoPor || h.usuarioModificacion || '—' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </f7-card-content>
        </f7-card>
      </div>

      <!-- Popup detalle herramienta -->
      <f7-popup :opened="detalleOpen" @popup:close="detalleOpen = false" class="tl-det-popup">
        <f7-page v-if="det">
          <f7-navbar>
            <f7-nav-left><f7-link popup-close icon-f7="xmark_circle" icon-size="20"></f7-link></f7-nav-left>
            <f7-nav-title>{{ (det.icono||'') + ' ' + det.nombre + ' — v.' + (det.version||1) }}</f7-nav-title>
            <f7-nav-right><f7-link popup-close :href="'/tarifas/editor-herramientas/'" icon-f7="pencil_circle" icon-size="20" v-tooltip="'Abrir en Editor'"></f7-link></f7-nav-right>
          </f7-navbar>
          <f7-page-content>
            <!-- 1. Datos generales -->
            <f7-card class="tl-dc"><div class="tl-dch">DATOS GENERALES</div>
              <f7-card-content><div class="tl-dg">
                <div class="tl-di"><span class="tl-dl">Codigo</span><span class="tl-dv"><b>{{ det.codigo }}</b></span></div>
                <div class="tl-di"><span class="tl-dl">Nombre</span><span class="tl-dv">{{ det.nombre }}</span></div>
                <div class="tl-di"><span class="tl-dl">Familia</span><span class="tl-dv">{{ det.familia }}</span></div>
                <div class="tl-di"><span class="tl-dl">Norma</span><span class="tl-dv">{{ det.norma || '—' }}</span></div>
                <div class="tl-di" v-if="det.subtitulo"><span class="tl-dl">Subtitulo</span><span class="tl-dv">{{ det.subtitulo }}</span></div>
                <div class="tl-di" v-if="det.icono"><span class="tl-dl">Icono</span><span class="tl-dv" style="font-size:18px">{{ det.icono }}</span></div>
              </div></f7-card-content>
            </f7-card>

            <!-- 2. Versionado -->
            <f7-card class="tl-dc"><div class="tl-dch">VERSIONADO</div>
              <f7-card-content><div class="tl-dg">
                <div class="tl-di"><span class="tl-dl">Version</span><span class="tl-dv">v.{{ det.version || 1 }}</span></div>
                <div class="tl-di"><span class="tl-dl">Fecha Desde</span><span class="tl-dv">{{ formatFecha(det.fechaDesde) }}</span></div>
                <div class="tl-di"><span class="tl-dl">Fecha Hasta</span><span class="tl-dv" :style="!det.fechaHasta?'color:#16a34a':''">{{ det.fechaHasta ? formatFecha(det.fechaHasta) : 'Vigente' }}</span></div>
                <div class="tl-di"><span class="tl-dl">Estado</span><span class="tl-badge" :class="esVigente(det)?'tl-vigente':'tl-cerrada'">{{ esVigente(det)?'Vigente':'Cerrada' }}</span></div>
                <div class="tl-di"><span class="tl-dl">Config Global</span><span class="tl-dv">{{ det.configGlobalVersion ? 'v.'+det.configGlobalVersion : '—' }}</span></div>
                <div class="tl-di" v-if="det.modificadoPor"><span class="tl-dl">Modificado por</span><span class="tl-dv">{{ det.modificadoPor }}</span></div>
                <div class="tl-di" v-if="det.motivo"><span class="tl-dl">Motivo</span><span class="tl-dv">{{ det.motivo }}</span></div>
              </div></f7-card-content>
            </f7-card>

            <!-- 3. Configuracion -->
            <f7-card class="tl-dc" v-if="det.config && configEntries.length"><div class="tl-dch">CONFIGURACION</div>
              <f7-card-content>
                <table class="tl-kv"><tbody>
                  <tr v-for="e in configEntries" :key="e.k"><td class="tl-kv-k">{{ e.k }}</td><td class="tl-kv-v">{{ e.v }}</td></tr>
                </tbody></table>
              </f7-card-content>
            </f7-card>

            <!-- 4. Formulas -->
            <f7-card class="tl-dc" v-if="det.formula && formulaEntries.length"><div class="tl-dch">FORMULAS</div>
              <f7-card-content>
                <table class="tl-kv"><tbody>
                  <tr v-for="e in formulaEntries" :key="e.k"><td class="tl-kv-k">{{ e.k }}</td><td class="tl-kv-v" style="font-family:monospace">{{ e.v }}</td></tr>
                </tbody></table>
              </f7-card-content>
            </f7-card>

            <!-- 5. Secciones -->
            <f7-card class="tl-dc" v-if="det.secciones && det.secciones.length"><div class="tl-dch">SECCIONES ({{ det.secciones.length }})</div>
              <f7-card-content>
                <div v-for="(sec, si) in det.secciones" :key="si" class="tl-sec-item">
                  <b>{{ si+1 }}.</b> {{ sec.titulo || 'Sin titulo' }}
                  <span v-if="sec.widgets" style="color:#94a3b8"> · {{ sec.widgets.length }} widgets</span>
                </div>
              </f7-card-content>
            </f7-card>

            <!-- 6. Subtipos -->
            <f7-card class="tl-dc"><div class="tl-dch">SUBTIPOS</div>
              <f7-card-content>
                <div v-if="!det.subtipos || !subtiposList.length" style="color:#94a3b8;font-size:11px">Sin subtipos definidos</div>
                <div v-else>
                  <div v-for="(st, si) in subtiposList" :key="si" class="tl-sec-item">{{ st }}</div>
                </div>
              </f7-card-content>
            </f7-card>

            <!-- 7. Alertas -->
            <f7-card class="tl-dc"><div class="tl-dch">ALERTAS</div>
              <f7-card-content>
                <div v-if="!det.alertas || !det.alertas.length" style="color:#94a3b8;font-size:11px">Sin alertas definidas</div>
                <div v-else>
                  <div v-for="(a, ai) in det.alertas" :key="ai" class="tl-alerta">{{ a.mensaje || a }}</div>
                </div>
              </f7-card-content>
            </f7-card>

            <!-- Botones -->
            <f7-block class="tl-det-btns">
              <f7-button fill color="orange" popup-close :href="'/tarifas/editor-herramientas/'">Abrir en Editor</f7-button>
              <f7-button fill color="blue" popup-close :href="'/tarifas/calculador-v3/' + det.codigo + '/'">Abrir en Calculador</f7-button>
              <f7-button popup-close>Cerrar</f7-button>
            </f7-block>
          </f7-page-content>
        </f7-page>
      </f7-popup>
    </f7-page-content>
  </f7-page>
</template>

<script>
import Tarifa from './../../js/db/Tarifa.js';
import cerrojoDeLaSesion from './../../js/utils/cerrojoDeLaSesion.js';

export default {
  data: function() {
    return {
      items: [],
      loading: false,
      filtro: { codigo: '', estado: '', fechaDesde: '', fechaHasta: '' },
      detalleOpen: false,
      det: null
    };
  },
  computed: {
    codigosUnicos: function() {
      var seen = {};
      return this.items.filter(function(h) {
        if (seen[h.codigo]) return false;
        seen[h.codigo] = true;
        return true;
      }).map(function(h) { return h.codigo; }).sort();
    },
    configEntries: function() {
      if (!this.det || !this.det.config) return [];
      var c = this.det.config;
      var relevantes = {
        'tpi_pct': 'TPI % sobre TPC',
        'f2tpc': 'Factor 2a TPC',
        'f2tpi': 'Factor 2a TPI',
        'tiene2a': 'Tiene 2a inspeccion',
        'kmmin': 'Km minimos (override)'
      };
      return Object.keys(relevantes).filter(function(k) {
        return c[k] !== undefined && c[k] !== null;
      }).map(function(k) {
        return { k: relevantes[k], v: String(c[k]) };
      });
    },
    formulaEntries: function() {
      if (!this.det || !this.det.formula) return [];
      var f = this.det.formula;
      return Object.keys(f).map(function(k) { return { k: k, v: String(f[k]) }; });
    },
    subtiposList: function() {
      if (!this.det || !this.det.subtipos) return [];
      var s = this.det.subtipos;
      if (Array.isArray(s)) return s.map(function(st) { return (st.codigo || '') + ' — ' + (st.nombre || st); });
      if (typeof s === 'object') return Object.keys(s).map(function(k) { return k + ' — ' + (s[k].nombre || s[k].label || JSON.stringify(s[k])).substring(0, 80); });
      return [];
    },
    herramientasFiltradas: function() {
      var self = this;
      var list = this.items;
      if (self.filtro.codigo) {
        list = list.filter(function(h) { return h.codigo === self.filtro.codigo; });
      }
      if (self.filtro.estado === 'vigente') {
        list = list.filter(function(h) { return self.esVigente(h); });
      } else if (self.filtro.estado === 'cerrada') {
        list = list.filter(function(h) { return !self.esVigente(h); });
      }
      if (self.filtro.fechaDesde) {
        list = list.filter(function(h) { return h.fechaDesde && h.fechaDesde >= self.filtro.fechaDesde; });
      }
      if (self.filtro.fechaHasta) {
        list = list.filter(function(h) { return h.fechaDesde && h.fechaDesde <= self.filtro.fechaHasta; });
      }
      return list;
    }
  },
  mounted: function() {
    this.cargar();
  },
  methods: {
    cargar: function() {
      var self = this;
      // #663 · Cerrojo de la sesión: si la sesión cambia en vuelo, la frontera calla la continuación que lo soltaba.
      cerrojoDeLaSesion(self, 'loading');
      Tarifa.getTodasHerramientas().then(function(res) {
        var list = res.list || res || [];
        list.sort(function(a, b) {
          var cmp = (a.codigo || '').localeCompare(b.codigo || '');
          if (cmp !== 0) return cmp;
          return (b.version || 0) - (a.version || 0);
        });
        self.items = list;
      }).catch(function() {
        self.items = [];
      }).finally(function() {
        self.loading = false;
      });
    },
    filtrar: function() { /* computed handles reactivity */ },
    limpiar: function() {
      this.filtro = { codigo: '', estado: '', fechaDesde: '', fechaHasta: '' };
    },
    esVigente: function(h) {
      return h.activo !== false && !h.fechaHasta;
    },
    formatFecha: function(str) {
      if (!str) return '—';
      try {
        var d = new Date(str);
        if (isNaN(d.getTime())) return str;
        return String(d.getDate()).padStart(2, '0') + '/' + String(d.getMonth() + 1).padStart(2, '0') + '/' + d.getFullYear();
      } catch (e) { return str; }
    },
    abrirDetalle: function(h) {
      this.det = h;
      this.detalleOpen = true;
    }
  }
};
</script>

<style scoped>
.tl-wrap { padding:8px; }
.tl-card { margin-bottom:10px; border-radius:7px; overflow:hidden; border:0.5px solid #e2e8f0; }
.tl-ch { padding:5px 8px; font-size:10px; font-weight:700; color:#fff; background:#1a2744; text-transform:uppercase; letter-spacing:.05em; display:flex; justify-content:space-between; align-items:center; }
.tl-ch-links { display:flex; }
.tl-filtros { display:flex; align-items:flex-end; gap:8px; flex-wrap:wrap; }
.tl-f-item { display:flex; flex-direction:column; gap:2px; }
.tl-f-item label { font-size:9px; font-weight:700; color:#555; text-transform:uppercase; }
.tl-select { padding:4px 6px; border:1px solid #d1d9e0; border-radius:4px; font-size:11px; min-width:130px; }
.tl-date { padding:4px 6px; border:1px solid #d1d9e0; border-radius:4px; font-size:11px; min-width:110px; }
.tl-empty { text-align:center; padding:20px; color:#999; font-size:11px; }
.tl-table { width:100%; border-collapse:collapse; font-size:11px; }
.tl-table th, .tl-table td { padding:5px 6px; border-bottom:1px solid #e2e8f0; text-align:left; white-space:nowrap; }
.tl-table th { font-weight:700; color:#555; background:#f8fafc; font-size:10px; position:sticky; top:0; }
.tl-table td { color:#333; }
.tl-row { cursor:pointer; transition:background .1s; }
.tl-row:hover { background:#fffbeb; }
.tl-row-closed { background:#f8fafc; opacity:.7; }
.tl-badge { display:inline-block; padding:2px 8px; border-radius:4px; font-size:9px; font-weight:700; }
.tl-vigente { background:#dcfce7; color:#16a34a; }
.tl-cerrada { background:#f1f5f9; color:#94a3b8; }
.tl-det-popup { --f7-popup-tablet-width:900px; }
.tl-dc { margin-bottom:8px; border-radius:7px; overflow:hidden; border:0.5px solid #e2e8f0; }
.tl-dch { padding:5px 8px; font-size:10px; font-weight:700; color:#fff; background:#1a2744; text-transform:uppercase; letter-spacing:.05em; }
.tl-dg { display:flex; gap:16px; flex-wrap:wrap; }
.tl-di { display:flex; flex-direction:column; gap:1px; min-width:100px; }
.tl-dl { font-size:9px; font-weight:700; color:#94a3b8; text-transform:uppercase; letter-spacing:.04em; }
.tl-dv { font-size:12px; font-weight:600; color:#1e293b; }
.tl-kv { width:100%; border-collapse:collapse; font-size:11px; }
.tl-kv td { padding:3px 6px; border-bottom:1px solid #f1f5f9; }
.tl-kv-k { font-weight:700; color:#555; width:140px; font-size:10px; text-transform:uppercase; }
.tl-kv-v { color:#1e293b; }
.tl-sec-item { font-size:11px; color:#333; padding:3px 0; border-bottom:1px solid #f1f5f9; }
.tl-alerta { font-size:11px; color:#92400e; padding:4px 8px; background:#fffbeb; border:1px solid #fde68a; border-radius:4px; margin-bottom:4px; }
.tl-det-btns { display:flex; gap:8px; flex-wrap:wrap; }
</style>
